import React from 'react';
import './style.scss';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import config from 'config';
import {Helper} from '../../../Helpers';
import _ from 'underscore';
import {Calendar as BigCalendar, momentLocalizer} from 'react-big-calendar';
import request from 'superagent';
import momenttz from 'moment-timezone';
import Toolbar from './Toolbar';
var ics = require('ics');

class Calendar extends React.Component {

  loadedMonths = [];

  calendarDetails = {};

  constructor(props) {
    super(props);

    const CALENDAR_ID = props.section.get('properties').calendar_id ? props.section.get('properties').calendar_id.id : null;
    this.API_KEY = 'AIzaSyD0iq6kqEnh8mr1-42nAudojdElsGTRte0';

    let calendars = this.props.section.prop('calendars');

    if (this.props.section.prop('calendar_options') && this.props.section.prop('calendar_options').localTimezone) {
      moment.tz.setDefault(FW.store.get('customer').get('timezone'));
    }

    this.localizer = momentLocalizer(moment);
    if (CALENDAR_ID && (!calendars || calendars.length === 0 || !calendars[0].id)) {
      calendars = [];
      calendars.push({
        id: CALENDAR_ID,
        color: null
      });
    }

    this.state = {
      moment: moment(),
      showPopover: false,
      showModal: false,
      overlayTitle: null,
      overlayContent: null,
      popoverTarget: null,
      calendarEvents: [],
      calendars: calendars,
      currentView: this.getCalendarView(),
      date: moment().toDate()
    };
  }

  componentDidMount() {
    this.loadCalendar();
  }

  componentDidUpdate() {
    this.state.calendars.forEach((calendar) => {
      const color = calendar.color;
      if (color) {
        const events = $('.' + color.replace('#', ''));
        events.css('background-color', color);
      }
    });
  }

  loadCalendar = () => {
    //Don't reload the same month, otherwise events multiply
    this.loadedMonths.push(this.state.moment.format("MMYY"));
    this.loadedMonths.push(moment(this.state.moment).add(45, 'days').format("MMYY"));
    let events = [];
    const num = this.state.calendars.length;
    let i = 0;
    this.state.calendars.forEach((calendar) => {
      this.getEvents(calendar.id, calendar.color, (e) => {
        events = events.concat(e);
        i++;
        if (i === num) {
          this.setState({
            calendarEvents: events
          });
        }
      });
    });
  };

  setDate(date) {
    //Load the months surrounding the date
    let m = new moment(date);
    this.setState({
      moment: m,
      date: date,
      scrollToTime: m.startOf('day').add(6, 'H').toDate()
    }, this.loadCalendar);
  }

  eventStyleGetter = (event, start, end, isSelected) => {
    const fontSize = this.props.section.prop('calendar_font_size') ? this.props.section.prop('calendar_font_size').size || 14 : 14;
    var style = {
      borderRadius: '4px',
      opacity: 0.8,
      border: '0px',
      display: 'block',
      fontSize: fontSize
    };
    if (this.state.currentView !== 'agenda' && event.hexColor) {
      style.backgroundColor = event.hexColor;
    } else if (event.hexColor) {
      style.borderLeft = '8px solid ' + event.hexColor;
      style.borderRadius = 0;
      style.display = 'table-row';
    }
    return {
      style: style
    };
  };

  getEvents = (calendarID, color, callback) => {
    //subtracting a few days and adding a few days helps when timezones don't line up
    const earliestDay = this.state.moment.startOf('month').clone().subtract(10, 'days').format();
    const lastDay = moment(earliestDay).clone().add(45, 'days').endOf('month').format();
    if (calendarID) {
      request
        .get(config.API_ROOT + `/calendar-proxy/${encodeURIComponent(calendarID)}/events?key=${this.API_KEY}&singleEvents=True` + '&timeMin=' + earliestDay + '&timeMax=' + lastDay + '&maxResults=1000')
        .end((err, resp) => {
          if (!err) {
            let events = [];
            let parsed = JSON.parse(resp.text);
            this.calendarDetails[calendarID] = parsed.summary;
            parsed.items.map((event) => {
              const startDate = event.start.dateTime || event.start.date;
              const endDate = event.end.dateTime || event.end.date;
              let startMoment = moment(startDate);
              let endMoment = moment(endDate);
              const allDayEvent = event.end.date && typeof event.end.dateTime === 'undefined';

              if (this.props.section.prop('calendar_options') && this.props.section.prop('calendar_options').localTimezone) {
                startMoment = startMoment.tz(FW.store.get('customer').get('timezone'));
                endMoment = endMoment.tz(FW.store.get('customer').get('timezone'));
              }

              let startTime, endTime;
              if (startMoment.day() !== endMoment.day()) {
                startTime = startMoment.format('MMM Do, LT');
                endTime = endMoment.format('MMM Do, LT');
              } else {
                startTime = startMoment.format('h:mm a');
                endTime = endMoment.format('h:mm a');
              }
              events.push({
                start: startMoment.toDate(),
                end: endMoment.toDate(),
                startTime: startTime,
                endTime: endTime,
                title: event.summary,
                description: event.description ? event.description.replace(/\n/g, '<br/>') : null,
                endMoment: endMoment,
                startMoment: startMoment,
                location: event.location,
                eventClasses: color ? color.replace('#', '') : null,
                hexColor: color,
                link: event.htmlLink,
                attachments: event.attachments,
                allDayEvent
              });
            });
            events = this.sortEvents(events);
            callback(events);
          } else {
            callback([]);
          }
        });
    }
  };

  sortEvents = (events) => {
    return events.sort((e, e2) => {
      if (e.startMoment.day() !== e.endMoment.day()) {
        if (e2.startMoment.day() !== e2.endMoment.day())
          return e.startMoment.isSameOrAfter(e2.startMoment) ? 1 : -1;
        return -1;
      }
      if (e2.startMoment.day() !== e2.endMoment.day())
        return 1;
      return e.startMoment.isSameOrAfter(e2.startMoment) ? 1 : -1;
    });
  };

  getHumanDate() {
    return [moment.months('MM', this.state.moment.month()), this.state.moment.year(),].join(' ');
  }

  getCalendarView = () => {
    let section = this.props.section;
    const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    let calendarView = windowWidth <= 576 ? 'agenda' : 'month';
    if (section.prop('calendar_options')) {
      let options = section.prop('calendar_options');
      calendarView = windowWidth <= 576 ? options.default_mobile_view || calendarView : options.default_view || calendarView;
    }
    calendarView = this.state && this.state.currentView || calendarView;
    return calendarView;
  };

  eventClicked = (event) => {
    let html = '';
    let options = this.props.section.prop('calendar_options') || {};

    if (event.startTime) {
      const diffInHours = event.endMoment.diff(event.startMoment, 'minutes') / 60;
      if(diffInHours < 24) {
        html += '<strong>Time: </strong>' + event.startTime + '-' + event.endTime + '<br/>';
      } else if (diffInHours === 24) {
        let allDay = options.hideAllDay ? '' : 'All Day ';
        html += allDay + event.startTime +' <br/>';
      } else if (diffInHours > 24) {
        const times = event.allDayEvent ? event.startMoment.format('MMM Do') + ' - ' + event.endMoment.subtract(1, 'second').format('MMM Do') : event.startDate + ' - ' + event.endTime;
        html += '<strong>Dates: </strong>' + times + '<br/>';
      }
    }
    if (event.location) {
      html += '<strong> Location: ' + event.location + '</strong><br/>';
    }
    if (event.description && event.description.toLowerCase() !== 'no description') {
      html += '<div style="text-align: left;">' + event.description + '</div>';
    }

    if (event.attachments && event.attachments.length > 0) {
      html += "<div style='text-align: left;'><h4>Event Attachments</h4><ul>";
      event.attachments.forEach((attachment) => {
        html += "<li><a href='" + attachment.fileUrl + "' target='_blank'>" + attachment.title + "</a></li>";
      });
      html += "</ul></div>";
    }

    let link = '';
    if (event.link) {
      try {
        let calendarAddLink = {
          text: event.title,
          dates: event.startMoment.format('YYYYMMDDTHHmmssZ') + "/" + event.endMoment.format('YYYYMMDDTHHmmssZ'),
          ctz: FW.store.get('customer').get('timezone'),
        };
        if (event.description) {
          calendarAddLink.details = encodeURIComponent(event.description);
        }
        if (event.location) {
          calendarAddLink.location = event.location;
        }
        link = 'https://www.google.com/calendar/render?action=TEMPLATE&' +
          _.map(calendarAddLink, (v, k) => {
            return k + '=' + v;
          }).join('&');
      } catch (error) {
        link = event.link;
      }

      if (Helper.isIOS()) {
        ics.createEvent({
          start: event.startMoment.toArray().slice(0, 5),
          end: event.endMoment.toArray().slice(0, 5),
          title: event.title,
          description: event.description,
          location: event.location,
          status: 'CONFIRMED',
          busyStatus: 'BUSY',
        }, (error, value) => {
          if (error) {
            console.log('ERROR: ', error, value);
            return
          }
          link = "data:text/calendar;charset=utf8," + escape(value);
        });
      }

      html += `<p><a href="${link}" target="_blank">Add to your calendar</a></p>`
    }
    if (html)
      swal.fire({
        title: event.title,
        showCloseButton: true,
        html: html,
        customClass: {
          content: 'swal-align-left'
        }
      });
  };

  getCalendarOption(option) {
    return this.props.section.prop('calendar_options') ? this.props.section.prop('calendar_options')[option] : null;
  }

  titleAccessor = (event) => {
    let html = event.title;
    let size = this.props.section.prop('calendar_font_size') ? this.props.section.prop('calendar_font_size').size : 14;
    const diffInHours = event.endMoment.diff(event.startMoment, 'minutes') / 60;
    let options = this.props.section.prop('calendar_options') || {};
    let allDay = options.hideAllDay ? '' : 'All Day';
    const timeString = diffInHours === 24 ? allDay : diffInHours > 24 ? '' : event.startMoment.format('h:mma');
    if (this.state.currentView === 'month' && !this.getCalendarOption('hideTimes')) {
      html = '<span style="font-size: 10px; vertical-align: top;">' + timeString
        + '</span> ' + '<span style="font-size: ' + size + '">' + event.title + '</span>';
    }
    return <span dangerouslySetInnerHTML={{__html: html}}/>
  };

  dayStyleGetter = (date) => {
    const section = this.props.section;
    const defaultColor = section.ls('cell_color') || '#FFFFFF';
    const defaultOpacity = typeof section.ls('cell_opacity') !== 'undefined' ? 100 * section.ls('cell_opacity') : 0;
    const outOfRangeColor = section.ls('other_month_cell_color') || '#e5e5e5';
    const outOfRangeOpacity = typeof section.ls('other_month_cell_opacity') !== 'undefined' ? 100 * section.ls('other_month_cell_opacity') : 100;
    const todayColor = section.ls('today_cell_color') || '#eaf6ff';
    const todayOpacity = typeof section.ls('today_cell_opacity') !== 'undefined' ? 100 * section.ls('today_cell_opacity') : 100;
    const activeDate = this.state.date;
    const today = new Date();
    let background;
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
      background = Helper.convertHexToRGBA(todayColor, todayOpacity);
    } else if (date.getFullYear() === activeDate.getFullYear() && date.getMonth() === activeDate.getMonth()) {
      background = Helper.convertHexToRGBA(defaultColor, defaultOpacity);
    } else {
      background = Helper.convertHexToRGBA(outOfRangeColor, outOfRangeOpacity);
    }
    return {
      style: {
        background: background
      }
    }
  };

  allDayAccessor = (event) => {
    const diffInHours = event.endMoment.diff(event.startMoment, 'minutes') / 60;
    return diffInHours === 24;
  };

  openRssLinks = () => {
    let inputs = '';
    _.each(this.calendarDetails, (obj, key) => {
      inputs += '<div style="padding: 10px;">' + obj + ': <a class="btn btn-default" href="https://calendar.google.com/calendar/ical/' + key + '/public/basic.ics">Add to Calendar</a></div>';
    });
    swal.fire({
      title: 'Add to Calendar',
      html: '<div>' +
        inputs +
      '</div>'
    });
  };

  render() {
    if (typeof moment.tz === 'undefined' || typeof request === 'undefined') {
      return null;
    }

    const chronologicalEvents = this.sortEvents([].concat.apply([], this.state.calendarEvents));
    let section = this.props.section;
    let sectionHeight = 500;
    if (section.prop('calendar_options')) {
      let options = section.prop('calendar_options');
      sectionHeight = options.height || sectionHeight;
    }
    const styles = {
      position: 'relative',
      height: sectionHeight
    };

    return (
      <div style={styles} className="calendarContainer">
        {FW.store.get('calendar-allowed-' + this.props.section.get('id')) ? (BigCalendar && this.localizer ? <BigCalendar
          localizer={this.localizer}
          events={chronologicalEvents}
          components={{
            agenda: {
              event: ({event}) => {
                const showDetails = () => {
                  this.eventClicked(event);
                }
                return <div onClick={showDetails} style={{cursor: 'pointer', textDecoration: 'underline'}}>{event.title}</div>;
              }
            },
            toolbar: (props) => {
              return <Toolbar {...props} rssClicked={this.openRssLinks} />;
            }
          }}
          startAccessor="start"
          endAccessor="end"
          eventPropGetter={this.eventStyleGetter}
          dayPropGetter={this.dayStyleGetter}
          allDayAccessor={this.allDayAccessor}
          popup={true}
          date={this.state.date}
          scrollToTime={this.state.scrollToTime}
          onSelectEvent={this.eventClicked}
          onView={(view) => {
            this.setState({currentView: view})
          }}
          onNavigate={(date) => {
            this.setDate(date)
          }}
          view={this.getCalendarView()}
          titleAccessor={this.titleAccessor}
        /> : null) : (FW.inEditor() ? <div style={{borderRadius: 5, height: '100%', padding: 100, fontSize: '2vw', textAlign: 'center', background: '#2f6686', color: '#fff'}}>
          Too Many Calendars<br /><br />
          Unlock this feature by upgrading your SK Sites package.<br /><br />
          Call 800-773-7570 option 1
        </div> : null)}
      </div>
    );
  }
}

export default Calendar;

